var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.095 9.22a.75.75 0 01.53-.22 9.383 9.383 0 016.626 2.75A9.395 9.395 0 0127 18.382a.75.75 0 11-1.5 0 7.891 7.891 0 00-2.31-5.57 7.88 7.88 0 00-5.565-2.31.75.75 0 01-.53-1.281zM20.55 20.575c.497 0 .974.197 1.325.549l1.59 1.592a1.877 1.877 0 010 2.653l-.873.873a2.656 2.656 0 01-3.3.332 35.19 35.19 0 01-9.857-9.864 2.635 2.635 0 01.332-3.303l.873-.874a1.875 1.875 0 012.65 0l1.593 1.593a1.881 1.881 0 010 2.653l-.29.289a35.13 35.13 0 004.342 4.345l.29-.29c.35-.35.828-.548 1.325-.548z",
    fill: "#0F0449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 13.503A4.88 4.88 0 0122.5 18.38a.75.75 0 101.5 0 6.38 6.38 0 00-6.375-6.38.75.75 0 000 1.502z",
    fill: "#0F0449"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.95 17.054a1.874 1.874 0 00-1.325-.55.75.75 0 010-1.5A3.377 3.377 0 0121 18.38a.75.75 0 11-1.5 0c0-.498-.198-.975-.55-1.327z",
    fill: "#0F0449"
  })));
}

export default SvgPhoneinline;